import { VueReCaptcha } from 'vue-recaptcha-v3';

const ReCaptchaPlugin = {
  install(app) {
    app.use(VueReCaptcha, {
      siteKey: import.meta.env.VITE_RECAPTCHA_KEY,
      loaderOptions: {
        autoHideBadge: true,
      },
    });
  },
};

export default ReCaptchaPlugin;
